



































































































































import { Component, Vue } from 'vue-property-decorator';
import ProviderBox from '@/components/ProviderBox/ProviderBox.vue';
import MerchantService from '@/api/MerchantService';
import eventBus from '@/utils/eventBus';
import { merchantoauthSessionKeys } from '@/constants/merchantoauth';
import MerchantOauthConnect, {
  getWoocommerceInitialUrl,
  OAUTH_IFRAME
} from '@/utils/merchantoauth';
import ShopifyTooltip from '@/components/ShopifyTooltip/ShopifyTooltip.vue';
import ApiTokenConnectProviderTooltip from '@/components/ApiTokenConnectProviderTooltip/ApiTokenConnectProviderTooltip.vue';
import BusinessService from '@/api/BusinessService';
import ModalOptions, { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import APIService from '@/api';
import ProvidersWebsiteModal from '@/constants/providersWebsiteModal';
import ProvidersApiTokenModal from '@/constants/providersApiTokenModal';
import { insideProviderIframe } from '@/utils/providerIframe';
import flagKeys from '@/constants/flagKeys';
import { EFeedbackDeactivationType } from '@/models/feedback';
import { IBusinessType } from '@/models/business';
import {
  IConnectOauth,
  IProvider,
  EConnectionTypeProvider
} from '@/models/provider';
import { EBusinessProviders } from '@/components/BusinessTypeSelector/business-providers.enum';
import { isOnlineProvider } from '@/utils/provider';
import { getSignUpUrl } from '../Onboarding/helpers';
import { setExternalOauthSession } from '@/router/router-utils';
import ToastConnectToolTip from '@/components/ToastConnectToolTip/ToastConnectToolTip.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import { isRemoteLoading } from '@/utils/remote-loading';

@Component({
  components: {
    ProviderBox,
    ContentContainer,
    ShopifyTooltip,
    ToastConnectToolTip,
    ApiTokenConnectProviderTooltip,
    Page
  }
})
export default class Integrations extends Vue {
  merchantService = new MerchantService();
  businessService = new BusinessService();
  providerTooltipVisibility: string = '';
  providerTooltipApiTokenVisibility: string = '';
  providersWebsiteModal = ProvidersWebsiteModal;
  providersApiTokenModal = ProvidersApiTokenModal;

  providers: any[] = [];
  loading = true;

  get tPrefix() {
    return 'appIntegrations.integrations';
  }

  get remoteLoading() {
    return isRemoteLoading();
  }

  get iframeProvider() {
    const oauthIframeData = JSON.parse(
      localStorage.getItem(OAUTH_IFRAME) || 'null'
    );
    return oauthIframeData ? oauthIframeData.provider : null;
  }

  get rewardsProgram() {
    return this.$store.getters['business/getRewardStatus'] || {};
  }

  get availables() {
    return this.providers.filter(
      provider =>
        provider.status === 'active' &&
        (!provider.connected || this.providerPending(provider.name)) &&
        (insideProviderIframe() ? this.iframeProvider === provider.name : true)
    );
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get connecteds() {
    return this.providers.filter(provider => provider.connected);
  }

  get comingSoon() {
    return this.providers.filter(provider => provider.status === 'soon');
  }

  get showJustConnectedProviders() {
    return this.connecteds.length > 0;
  }

  providerPending(provider: string) {
    if (!this.rewardsProgram.providers) return false;

    const providerSquare = this.rewardsProgram.providers.filter(
      (ele: any) => ele.provider === EBusinessProviders.SQUARE
    )[0];

    return (
      providerSquare &&
      this.rewardsProgram.operationStatus === 'active' &&
      provider === EBusinessProviders.SQUARE &&
      providerSquare.rewardStatus === 'pending'
    );
  }

  shouldOpenModalConnectProvider(provider: IProvider) {
    if (
      provider.name === EBusinessProviders.CLOVER &&
      provider.authType === EConnectionTypeProvider.OAUTH
    ) {
      return false;
    }

    return this.providersWebsiteModal.includes(provider.name);
  }

  isProviderSelected(providerName: string) {
    return providerName === this.providerTooltipVisibility;
  }

  isProviderSelectedApiToken(provider: IProvider) {
    return (
      provider.authType === EConnectionTypeProvider.API_TOKEN &&
      this.providersApiTokenModal.includes(provider.name)
    );
  }

  toggleProviderVisibility(providerName: string) {
    return this.isProviderSelected(providerName) ? '' : providerName;
  }

  closeShopifyTooltip() {
    this.providerTooltipVisibility = '';
  }

  gaSend(provider: string) {
    this.$ga.event({
      eventCategory: 'integrations',
      eventAction: 'click',
      eventLabel: `connect-${provider}`
    });
  }

  async connect(index: number, params?: string | Object) {
    const { links, features, authType, name: providerName } = this.availables[
      index
    ];
    this.availables[index].loading = true;

    const onlineConnectedProvider = this.connecteds.find(provider =>
      provider.features.includes('coupons')
    );
    if (features.includes('coupons') && onlineConnectedProvider) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptions(
          ``,
          ``,
          'none',
          true,
          ``,
          ``,
          ``,
          false,
          'onlineProviderModal',
          false,
          true,
          true
        ),
        {
          providerToConnect: {
            ...this.availables[index],
            params
          },
          providerToDisconnect: onlineConnectedProvider,
          onClose: () => {
            this.availables[index].loading = false;
          }
        }
      );
    } else {
      const typeConnection =
        authType === 'oauth' ? 'connect' : 'connectApiToken';

      try {
        const respConnect = await MerchantOauthConnect(
          links,
          typeConnection,
          params
        );

        if (
          respConnect &&
          respConnect.status === 200 &&
          typeConnection === 'connectApiToken'
        ) {
          this.$notification(`${providerName} connected.`, 'success');
          this.initProviders();
        }
      } catch (err) {
        this.$notification(
          String(this.$t(`${this.tPrefix}.formInvalid.error`)),
          'error'
        );
      } finally {
        if (
          params &&
          typeof params === 'object' &&
          'onSuccess' in params &&
          typeof (params as any).onSuccess === 'function'
        ) {
          (params as any).onSuccess();
        }
      }
    }
  }

  async disconnectProvider(
    index: number,
    name: string,
    showNotification: boolean = true
  ) {
    const { links } = this.connecteds[index];
    this.connecteds[index].loading = true;
    const response = await this.merchantService.disconnect(links.oauthRevoke);
    if (response && response.status === 200) {
      if (showNotification)
        this.$notification(
          String(
            this.$t(`${this.tPrefix}.disconnect.successMessage`, { name })
          ),
          'success'
        );

      this.$store.dispatch('merchant/SET_PROVIDERS_TO_UPDATE', []);
      this.$store.dispatch('businessOnboarding/RESET_BUSINESS_ONBOARDING');

      if (insideProviderIframe()) {
        APIService.resetCredentials(() => {
          if (this.connecteds[index].name === 'woocommerce') {
            return (window.location.href = getWoocommerceInitialUrl());
          }
          setExternalOauthSession(
            isOnlineProvider(this.connecteds[index].name)
              ? IBusinessType.ONLINE
              : IBusinessType.INSTORE
          );

          const onboardingOnlinePage = getSignUpUrl();

          this.$router.push(
            `${onboardingOnlinePage}?providerName=${
              this.connecteds[index].name
            }&providerId=${this.connecteds[index].oauthId}`
          );
        });
      } else {
        await this.initProviders();
      }
    }
  }

  async disconnect(index: number, name: string) {
    if (
      isOnlineProvider(this.connecteds[index].name) &&
      this.business.type !== IBusinessType.INSTORE &&
      this.getFlags.includes(flagKeys.deactivationFeedback)
    ) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: 'deactivationReviewModal',
          hideCancelButton: false,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: false
        }),
        {
          type: EFeedbackDeactivationType.PROVIDER_DISCONNECTED,
          onSuccess: () => {
            this.disconnectProvider(index, name);
          }
        }
      );
    } else {
      this.disconnectProvider(index, name);
    }
  }

  async retry(index: number, name: string) {
    await this.disconnectProvider(index, name, false);
    const indexAvailable = this.availables.findIndex(
      provider => provider.name === name
    );
    setTimeout(() => {
      this.connect(indexAvailable);
    }, 100);
  }

  created() {
    this.initProviders();
  }

  mounted() {
    this.displayMessage();
    // The connected list is filled by the router bootstrap, which can land
    // before or after this screen mounts.
    this.$store.watch(
      (_, getters) => getters['merchant/getConnectedProvidersList'],
      connections => this.loadProvidersToUpdate(connections),
      { immediate: true }
    );
  }

  // Feeds `providersToUpdate`, which ProviderBox reads to flag an API-token
  // connection as "Action needed". The merchant-wide update banner lives in
  // the portal shell, not here.
  async loadProvidersToUpdate(connections: IConnectOauth[]) {
    if (!connections) return;

    const outdated = await Promise.all(
      connections
        .filter(connection => connection.provider !== 'fidel')
        .map(async connection => {
          try {
            const response = await this.merchantService.shouldUpdate(
              connection.id
            );
            return response.data.needsUpdateScope ? connection : null;
          } catch (error) {
            return null;
          }
        })
    );

    this.$store.dispatch(
      'merchant/SET_PROVIDERS_TO_UPDATE',
      outdated.filter(Boolean)
    );
  }

  displayMessage() {
    const errorMessage = sessionStorage.getItem(
      merchantoauthSessionKeys.connect.error
    );

    if (errorMessage) {
      this.$notification(errorMessage, 'error');
      sessionStorage.removeItem(merchantoauthSessionKeys.connect.error);
    }

    const successMessage = sessionStorage.getItem(
      merchantoauthSessionKeys.connect.success
    );

    if (successMessage) {
      this.$notification(successMessage, 'success');
      sessionStorage.removeItem(merchantoauthSessionKeys.connect.success);
    }
  }

  async initProviders() {
    this.$showLoaderWithLocker();

    const response = await this.merchantService.listProviders();
    const providers = response.data.providers as IProvider[];
    await this.$store.dispatch('merchant/SET_PROVIDERS_LIST', providers);

    providers.forEach((provider: any) => {
      provider.loading = false;
    });

    this.$hideLoader();
    this.loading = false;
    this.providers = providers;
  }
}
